import { formatMultipleSortingForEndpoint } from '@app/components/data-table/lib/parsers';
import Page from '@app/components/layout/page/page';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { useGetPurchasedFoodAndDrinkList } from '@shared/api/hooks/purchased-goods/food-and-drink';
import { PurchasedGoodsFoodListParams } from '@shared/api/types';
import { parseAsString, useQueryState } from 'nuqs';
import PurchasedFoodAndDrinkTable from '../components/purchased-food-and-drink-table';
import { buildFoodFilterParams, foodFilters } from '../filters';

export default function PurchasedFoodAndDrinkListPage() {
  const { page, perPage, sort, ...filterStates } = useDataTableQueryState({
    filters: Object.values(foodFilters).map(({ column }) => column),
  });
  const [food] = useQueryState('food', parseAsString);

  const params: PurchasedGoodsFoodListParams = {
    page,
    page_size: perPage,
    search: food!,
    sort: formatMultipleSortingForEndpoint(sort! || []),
    ...buildFoodFilterParams(filterStates),
  };

  const data = useGetPurchasedFoodAndDrinkList(params);

  return (
    <Page name="Food and drink" page="subpage">
      <PurchasedFoodAndDrinkTable {...data} />
    </Page>
  );
}
